var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronStart = function SvgChevronStart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.477 6.6a.56.56 0 0 0 0 .795l3.75 3.752a.562.562 0 0 0 .795-.795L3.67 7l3.353-3.352a.562.562 0 0 0-.795-.795zm8.25-3.75L6.977 6.6a.56.56 0 0 0 0 .795l3.75 3.752a.562.562 0 0 0 .795-.795L8.17 7.003l3.353-3.355a.562.562 0 0 0-.795-.795z"
  })));
};
export default SvgChevronStart;